import {Token, QuestsApi, QuestProgression} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useQuery} from "@tanstack/react-query";

async function fetchQuestProgressionForUser(fullToken: Token, questConfigIds: Array<string>): Promise<Array<QuestProgression>> {
    return await new QuestsApi(getConfig(fullToken)).getQuestProgressionForUser({
        questConfigIds: questConfigIds,
    });
}

function getQuestProgressionForUserQuery(fullToken: Token, questConfigIds: Array<string>) {
    const enabled = Boolean(fullToken && questConfigIds?.length > 0);

    const sortedQuestConfigIds = [...questConfigIds].sort();

    return {
        queryKey: [
            "quest-progression-user",
            fullToken?.id ?? "unauthenticated",
            ...sortedQuestConfigIds,
        ],
        queryFn: () => fetchQuestProgressionForUser(fullToken, sortedQuestConfigIds),
        keepPreviousData: true,
        staleTime: 30 * 24 * 60 * 60000,
        refetchOnWindowFocus: false,
        enabled: enabled,
    } as const;
}

export function useGetQuestProgressionForUser(fullToken: Token, questConfigIds: Array<string>) {
    return useQuery(getQuestProgressionForUserQuery(fullToken, questConfigIds));
}